module.exports = __webpack_public_path__ + "img/jrylLogo.bd95ad80.png";